export const setupAndroidViewportReset = () => {
  const isAndroid = /android/i.test(navigator.userAgent || '');
  if (!isAndroid) return;

  let pending = false;

  const resetViewport = () => {
    if (pending) return;
    pending = true;

    window.setTimeout(() => {
      const html = document.documentElement;

      const prevMinHeight = html.style.minHeight;
      html.style.minHeight = '100vh';

      void html.offsetHeight;

      html.style.minHeight = prevMinHeight;
      pending = false;
    }, 100);
  };

  window.addEventListener('focusout', resetViewport);

  return () => {
    window.removeEventListener('focusout', resetViewport);
  };
};
